var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var SHOP_ROOT = '/shop';
var DEFAULT_PRODUCT = 't-shirts';
var parseQueryString = function (queryString) {
    if (queryString === void 0) { queryString = ''; }
    return queryString
        .split('&')
        .filter(Boolean)
        .map(function (pair) { return pair.split('='); })
        .reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
    }, {});
};
var normaliseSearchQuery = function (rawQuery) {
    if (!rawQuery)
        return '';
    try {
        return decodeURIComponent(rawQuery.replace(/\+/g, ' '))
            .trim()
            .toLowerCase()
            .replace(/\s+/g, ' ');
    }
    catch (_a) {
        return '';
    }
};
var setOrRemove = function (target, current) {
    if (target === current)
        return undefined;
    if (target) {
        return target;
    }
    return current;
};
export var isActiveSelection = function (itemCategory, _a) {
    var currentNavTopic = _a.topic, currentNavProduct = _a.product;
    return (itemCategory.topic === currentNavTopic && !!currentNavTopic) ||
        (itemCategory.product === currentNavProduct && !!currentNavProduct);
};
/**
 * Owns both directions of topic nav routing so they can't drift apart:
 * `buildHref` produces the locations for the given `behaviour`, and
 * `deriveState` reads any location we (or the search bar) may have produced
 * back into the selected topic and product.
 */
export var createTopicNavRouting = function (config, behaviour) {
    if (behaviour === void 0) { behaviour = 'category-page'; }
    var isTopic = function (slug) {
        return config.topics.some(function (_a) {
            var topic = _a.category.topic;
            return topic === slug;
        });
    };
    var searchTermFor = function (product) {
        var _a, _b;
        return (_b = (_a = config.products.find(function (_a) {
            var category = _a.category;
            return category.product === product;
        })) === null || _a === void 0 ? void 0 : _a.searchTerm) !== null && _b !== void 0 ? _b : product;
    };
    // Reads "music", "t-shirts" or "music tshirts" style searches into a topic
    // and/or product.
    var deriveStateFromSearchQuery = function (rawQuery) {
        var query = normaliseSearchQuery(rawQuery);
        if (!query)
            return {};
        if (isTopic(query))
            return { topic: query };
        for (var _i = 0, _a = config.products; _i < _a.length; _i++) {
            var category = _a[_i].category;
            var product = category.product;
            if (!product)
                continue;
            var terms = [product, searchTermFor(product)];
            if (terms.includes(query))
                return { product: product };
            var term = terms.find(function (t) { return query.endsWith(" ".concat(t)); });
            if (term) {
                var topic = query.slice(0, -(term.length + 1));
                if (isTopic(topic))
                    return { topic: topic, product: product };
            }
        }
        return {};
    };
    var deriveState = function (path) {
        var _a, _b, _c, _d;
        /*
        The locations take the following forms:
    
        /shop/<topic>
        /shop/<product>
        /shop/<topic>+<product>
        /shop?query=<search_term>          (search bar, or the dynamic-query behaviour)
        /shop?query=<topic>%20<product>    (dynamic-query behaviour)
    
        A ?query= term drives an active topic or product when it matches a
        configured topic/product; otherwise nothing from the query is considered active.
        */
        var _e = path.split('?').filter(Boolean), pathname = _e[0], _f = _e[1], queryString = _f === void 0 ? '' : _f;
        var rawSearchQuery = parseQueryString(queryString).query;
        var searchState = deriveStateFromSearchQuery(rawSearchQuery);
        var _g = ((_a = pathname === null || pathname === void 0 ? void 0 : pathname.split('/')) !== null && _a !== void 0 ? _a : []).filter(Boolean), root = _g[0], item = _g[1];
        var _h = (_b = item === null || item === void 0 ? void 0 : item.split('+')) !== null && _b !== void 0 ? _b : [], rawTopic = _h[0], rawConjunctProduct = _h[1];
        if (root !== 'shop')
            return {};
        if (rawConjunctProduct) {
            var isProduct = config.products.some(function (_a) {
                var product = _a.category.product;
                return product === rawConjunctProduct;
            });
            if (isTopic(rawTopic) && isProduct) {
                return { topic: rawTopic, product: rawConjunctProduct };
            }
            return {};
        }
        var topic = (_c = config.topics.find(function (_a) {
            var topic = _a.category.topic;
            return topic === rawTopic || topic === searchState.topic;
        })) === null || _c === void 0 ? void 0 : _c.category.topic;
        var product = (_d = config.products.find(function (_a) {
            var product = _a.category.product;
            return product === item || product === searchState.product;
        })) === null || _d === void 0 ? void 0 : _d.category.product;
        return { topic: topic, product: product };
    };
    var buildPathHref = function (topic, product) {
        var encodedTopic = topic && encodeURIComponent(topic);
        var encodedProduct = product && encodeURIComponent(product);
        if (encodedTopic) {
            var topicHref = [SHOP_ROOT, encodedTopic].join('/');
            return encodedProduct ? [topicHref, encodedProduct].join('+') : topicHref;
        }
        if (encodedProduct)
            return [SHOP_ROOT, encodedProduct].join('/');
        return SHOP_ROOT;
    };
    var buildSearchHref = function (topic, product) {
        var query = [topic, product && searchTermFor(product)]
            .filter(Boolean)
            .join(' ');
        return "".concat(SHOP_ROOT, "?query=").concat(encodeURIComponent(query), "&ref=search_box");
    };
    var buildHref = function (target, current) {
        var topic = setOrRemove(target.topic, current.topic);
        var product = setOrRemove(target.product, current.product);
        if (topic &&
            (behaviour === 'default-tshirts' || behaviour === 'dynamic-query')) {
            // A topic is never shown without a product: both a topic click and
            // deselecting a product default to T-shirts (DEAP-6061). This means the
            // T-shirts chip can't be toggled off while a topic is selected.
            product !== null && product !== void 0 ? product : (product = DEFAULT_PRODUCT);
            if (behaviour === 'dynamic-query')
                return buildSearchHref(topic, product);
        }
        if (!topic && !product) {
            var nothingSelected = !target.topic && !target.product && !current.topic && !current.product;
            if (nothingSelected)
                return undefined;
        }
        return buildPathHref(topic, product);
    };
    return { deriveState: deriveState, buildHref: buildHref, isActive: isActiveSelection };
};
